import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import LocalizedField from './LocalizedField';
import SectionBlock from './SectionBlock';

export default function BoothDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  return (
    <Box>
      <SectionBlock title="Identity" />
      <LocalizedField
        label="Name"
        fieldKey="localizedPairs"
        data={data.localizedPairs}
        diffKeys={diffKeys}
        side={side}
      />
      <FieldRow
        label="Map Spot ID"
        value={data.mapSpotId != null ? String(data.mapSpotId) : null}
        isChanged={diffKeys.has('mapSpotId')}
        side={side}
      />
      <FieldRow
        label="Icon"
        value={data.iconKey ?? 'Auto (from name)'}
        isChanged={diffKeys.has('iconKey')}
        side={side}
      />
    </Box>
  );
}
